import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { ToastService } from 'src/utils/toast.service';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService {
  private readonly toastService = inject(ToastService);
  private readonly destroyRef = inject(DestroyRef);

  private readonly onlineSignal = signal(navigator.onLine);
  private offlineToastId: number | null = null;

  readonly online = this.onlineSignal.asReadonly();

  private readonly onOffline = () => {
    this.onlineSignal.set(false);
    if (this.offlineToastId !== null) return;

    this.offlineToastId = this.toastService.danger('Sin conexión. Revisa tu red para continuar.', {
      duration: 0,
    });
  };

  private readonly onOnline = () => {
    this.onlineSignal.set(true);
    if (this.offlineToastId !== null) {
      this.toastService.remove(this.offlineToastId);
      this.offlineToastId = null;
    }
    this.toastService.success('Conexión restablecida.');
  };

  constructor() {
    window.addEventListener('offline', this.onOffline);
    window.addEventListener('online', this.onOnline);

    this.destroyRef.onDestroy(() => {
      window.removeEventListener('offline', this.onOffline);
      window.removeEventListener('online', this.onOnline);
    });
  }

  notifyRequestFailure(retry: () => void): void {
    this.toastService.danger('No pudimos conectar. Verifica tu conexión.', {
      duration: 8000,
      action: { label: 'Reintentar', handler: retry },
    });
  }
}
